import "./terms.css"

function Terms(){
   return( 
   <div className="div">
    <div className="img12">
        <a href="https://33472-3.tiiny.site">
         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" 
         d="m12 16l4-4l-1.4-1.4l-1.6 1.55V8h-2v4.15L9.4 10.6L8 12zm-7 7V1h14v5.1h1v4.8h-1V23z"/></svg>
         <h1>see the terms document here</h1>
        </a>
    </div>
    </div>
   )
}
export default Terms